import React from "react";
import { OutletClosedIcon } from "../../../utils/svg";

const OutletClosedModal = ({ open, onBackHome }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      
      <div className="bg-white rounded-2xl shadow-lg w-[90%] max-w-sm px-6 py-8 text-center">
        
        <div className="flex justify-center mb-4">
          <OutletClosedIcon />
        </div>

        <h3 className="text-base font-semibold text-gray-900 mb-2">
          Maaf, restoran sudah tutup
        </h3>

        <p className="text-sm text-gray-500 mb-6">
          Ingin memesan dari restoran lain?
        </p>

        <button
          onClick={onBackHome}
          className="w-full border border-[var(--rose-violet)] text-[var(--rose-violet)] font-semibold py-3 rounded-xl transition mb-2"
        >
          Kembali ke Beranda
        </button>
      </div>
    </div>
  );
};

export default OutletClosedModal;